module.exports = [{
  code: 0,
  name: 'products-quality',
  title: 'Qualité',
  description: 'Il y avait un problème avec la qualité des produits'
},{
  name: 'products-missing',
  title: 'Produits manquants',
  description: 'Il manquait beaucoup de produits',
  code: 1
},{
  title: 'Service client',
  description: 'Il y avait un problème avec la service client',
  code: 2,
  name: 'customer-service'
},{
  code: 3,
  name: 'delivery',
  title: 'Livraison',
  description: 'Il y avait un problème avec la livraison'
},{
  code: 4,
  name: 'employee',
  title: 'Avoir salarié',
  description: 'Paniers prix coutant salariés'
},{
  code: 5,
  name: 'referral-gift',
  title: 'Cadeau parainnage',
  description: 'Un cadeau consommateur pour la parainnage'
}];